import React, { useEffect, useState, useCallback } from 'react'

import classnames from 'classnames'
import styles from './FadeOut.module.scss'

export default React.memo(function FadeOut({ children, visible }) {
  const [className, setClassName] = useState()

  useEffect(() => {
    if (!visible) {
      setClassName(styles.out)

      setTimeout(() => {
        setClassName(styles.hide)
      }, 1000)
    }
  }, [visible])

  return (
    <div className={classnames(styles.container, className)}>
      {children}
    </div>
  )
})
